var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwapHorizontalCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 14.8v-3.6h-8.1V3.6h8.1V0l11.1 6.4a1.133 1.133 0 0 1 0 2zm-6.8-4.9h8.1v2.7l9.1-5.2-9.1-5.2v2.7h-8.1zm.2 20.1L.6 23.6a1.133 1.133 0 0 1 0-2l11.1-6.4v3.6h8.1v7.6h-8.1V30zM1.4 22.6l9.1 5.2v-2.7h8.1V20h-8.1v-2.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapHorizontalCircle);
export default __webpack_public_path__ + "static/media/swapHorizontalCircle.1a76d0dfa36be825a3ef496e4eecb580.svg";
export { ForwardRef as ReactComponent };